// extracted by mini-css-extract-plugin
export default {"main-container":"QuickPosting_main-container__UQ7LW","details-textbox":"QuickPosting_details-textbox__SuhyF"};